<template>
    <TopCard v-if="posts" :post="posts[0]"></TopCard>
    <GridDisplay title="Recomendados para ti" :method="setSong" :posts="posts"/>
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue';
export default {
  components: { TopCard, GridDisplay },
    name:'CancionesView',
    data() {
        return{
            posts: [],
        }    
    },
    mounted(){       
        if(localStorage.getItem('token')!==null){
          const url= this.baseUrl + '/user/me/recommendations/tracks?access_token='+localStorage.getItem('token');
          fetch(url)
            .then(response=>response.json())
            .then(json=>this.posts = json.data);
        } else{
          const url= this.baseUrl + '/chart/0/tracks?index=0&limit=14'
          fetch(url)
            .then(response=>response.json())
            .then(json=>this.posts = json.data);
        }    
    },
    methods:{
        setSong(song){
            const url = this.baseUrl + '/track/'+song.id
            fetch(url)
                .then(response=>response.json())
                .then(json=> localStorage.setItem('currentSong', JSON.stringify(json)));
        }
    }
}
</script>